export default __webpack_public_path__ + "static/media/damage_road.fa12bee9.svg";